import script from "./PeriodGames.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodGames.vue?vue&type=script&setup=true&lang=js"

import "./PeriodGames.vue?vue&type=style&index=0&id=c46526c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c46526c6"]])

export default __exports__